module.exports = __webpack_public_path__ + "img/title1.166baf35.png";